import { GetAttr } from './utils/getAttr'
import { bubble } from './utils/bubble'
export default class SyncManager {

  els = {
    mainEl: "[data-js-sync-main]",
    duplicateEl: "[data-js-sync-duplicate]",
    typeForObserve: "[data-js-sync-type]"
  }

  bubbles = {
    "mainSync":"SyncManager::syncWithMain"
  }

  constructor (props) {
    this.mainEls = document.querySelectorAll(this.els.mainEl)
    this.duplicateEls = document.querySelectorAll(this.els.duplicateEl)
    this.syncStates = new Map();
    this.bindEvents();
  }


  setSyncState(el, state) {
    this.syncStates.set(el, state);
  }

  getSyncState(el) {
    return this.syncStates.get(el) || false;
  }

  handleDuplicate(e, trigger) {
    const target = e.target;
    if (this.getSyncState(target)) {return;}

    this.setSyncState(target, true);

    const syncType = target.getAttribute(GetAttr(this.els.typeForObserve));
    const syncAttr = trigger.hasAttribute(GetAttr(this.els.mainEl)) ? GetAttr(this.els.duplicateEl) : GetAttr(this.els.mainEl);
    const triggerValue = trigger.getAttribute(GetAttr(this.els.mainEl)) || trigger.getAttribute(GetAttr(this.els.duplicateEl))
    const syncSelector = `[${syncAttr}=${triggerValue}]`
    const relatedEls = document.querySelectorAll(syncSelector);

    relatedEls.forEach(el => {
      if (el !== target) {
        el.checked = target.checked;
      }
    });

    this.setSyncState(target, false);

    if (syncAttr === GetAttr(this.els.mainEl)) {
      bubble(document, this.bubbles.mainSync, ) //bubble события для каталог фильтра, если в правом сайдабаре произошли изменения (для синхронизированных элементов на главном фильтре) - тригер на запрос
    }
  }

  bindEvents() {
    this.mainEls.forEach(el => {
      let selector = el.getAttribute(GetAttr(this.els.typeForObserve))
      if (el.matches(selector)) {
        el.addEventListener("change", (e) => this.handleDuplicate(e, el))
      } else {
        let observeEl = el.querySelector(selector)
        if (observeEl) {
          observeEl.addEventListener("change", (e) => {
            this.handleDuplicate(e, el)
          })
        }
      }
    })
    this.duplicateEls.forEach(el => {
      let selector = el.getAttribute(GetAttr(this.els.typeForObserve))
      if (el.matches(selector)) {
        el.addEventListener("change", (e) => this.handleDuplicate(e, el))
      } else {
        let observeEl = el.querySelector(selector)
        if (observeEl) {
          observeEl.addEventListener("change", (e) => {
            this.handleDuplicate(e, el)
          })
        }
      }
    })
  }



}
